import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { Language, TranslationService } from '../../Services/translation.service';

@Component({
  selector: 'av-language-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule
  ],
  templateUrl: './av-language-dropdown.component.html',
  styleUrls: ['./av-language-dropdown.component.scss']
})
export class AvLanguageDropdownComponent {
  private _translationService = inject(TranslationService);
  
  readonly languages = this._translationService.availableLanguages;
  readonly currentLangCode = this._translationService.currentLanguage;
  readonly currentLangLabel = computed(() => {
    const current = this.languages.find(l => l.code === this.currentLangCode());
    return current ? current.label : 'English';
  });

  selectLanguage(lang: Language): void {
    this._translationService.setLanguage(lang);
  }
}